export const WorkspaceDetailsTabsEnum = {
  OVERVIEW: 0,
  USERS: 1,
  ACTIVITY_LOG: 2,
};

export default WorkspaceDetailsTabsEnum;

